import { useEffect } from "react"
import { useParams } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const useGetSeriesDetail = () => {
    const { idx } = useParams()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    useEffect(() => {
        fetchRequest("GET", `/event/series/${idx}`)
    }, [])

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("대회 시리즈 데이터가 존재하지 않습니다.")
                break
        }
    }, [fetchResult])

    return [fetchResult]
}

export default useGetSeriesDetail